import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createBlock(_resolveDynamicComponent($setup.isLogin ? $setup.Logged : $setup.Logout), {
    nickname: $setup.nickname,
    onGetUserInfo: $setup.init
  }, null, 40, ["nickname"]))], 512)), [[_vShow, $setup.showLoginBox]]);
}